import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractComponent } from '@components';
import { ActionResultList, Country, EventItem, EventItemType, EventRaceItem, Lookups } from "@model";
import { EventRaceService, EventService } from '@services';
import { EVENT_DETAILS } from 'src/app/app-routing.module';

@Component({
  selector: 'app-user-profile-wish-list-tab',
  templateUrl: './user-profile-wish-list-tab.component.html',
  styleUrls: ['./user-profile-wish-list-tab.component.scss']
})
export class UserProfileWishListTabComponent extends AbstractComponent implements OnInit {

  @Input() favoriteItems: EventItem[] = [];
  @Input() countries: Country[] = [];
  @Input({ required: true }) languages: Lookups[] = [];
  @Input() isOnWishList: boolean = true;

  calendarType: EventItemType = EventItemType.MY_FAVORITE;
  EventItemType = EventItemType;
  isLoading: boolean = false;

  constructor(private router: Router, private route: ActivatedRoute, private eventService: EventService) {
    super();
  }
  ngOnInit(): void {
    this.subscribeToFavoritesChange();
   
  }

  trackByFn(index: number, item: EventRaceItem) {
    return item.id;
  }

  subscribeToFavoritesChange(): void {
    this.subscriptions.push(this.eventService.favoriteEvents.subscribe((value: ActionResultList<EventItem[], number> | null) => {
      if (value && value.result?.length !== undefined) {
        this.favoriteItems = value.result;
      } else {
        this.favoriteItems = [];
      }
    }))
  }

  goToEventDetailsPage(item: EventItem) {
    this.router.navigate([EVENT_DETAILS], {
      relativeTo: this.route,
      queryParams: { eventId: item.id }
    });
  }
}
